import {
  STATUS_FILTER,
  YES_NO_OPTIONS,
  DISPATCHED_BY_FILTER,
  DISPATCHED_SERIAL_NO_FILTER,
  DISPATCHED_GMDS_CODE_FILTER,
} from "../../custom/Utils/ListFilterOptions";

const schema = localStorage.getItem("schema");
export const basicFormData = () => ({
  inputData: {
    job_card_no: "",
    remark: "",
    created_by: "",
    updated_by: "",
    is_active: true,
  },
});

export const createPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "dispatcheds",
    schema: schema,
    include: [
      {
        model: "material_intakes",
        as: "intake",
      },
      {
        model: "user_masters",
        as: "dispatched_by_user",
      },
      {
        model: "job_cards",
        as: "job_card",
      },
    ],
  };

  const navigatePage = { back: "/dispatched-list" };

  const headerName = "Dispatched";

  const validationType = "DispatchedCreate";
  const createEndpoint = "/updaterelationaldata  ";
  const updateEndpoint = "/updaterelationaldata  ";
  const getEndpoint = "/getRecords";
  // dispatches one or many job cards in a single all-or-nothing transaction
  const bulkDispatchEndpoint = "/dispatch/bulk";

  return {
    payload,
    navigatePage,
    headerName,
    validationType,
    createEndpoint,
    updateEndpoint,
    getEndpoint,
    bulkDispatchEndpoint,
  };
};

export const listPageData = () => {
  const schema = localStorage.getItem("schema");

  const payload = {
    modelName: "dispatcheds",
    schema: schema,
    include: [
      {
        model: "material_intakes",
        as: "intake",
        include: [
          {
            model: "material_masters",
            as: "material",
          },
        ],
      },
      {
        model: "user_masters",
        as: "dispatched_by_user",
      },
      {
        model: "job_cards",
        as: "job_card",
      },
    ],
  };

  const columnData = [
    { label: "Sr.no", value: "index" },
    { label: "Dispatched By", value: "dispatched_by_user_full_name" },
    { label: "Intake No", value: "intake.intake_no" },
    { label: "Dispatched Date", value: "dispatch_date" },
    { label: "Remark", value: "remark" },
    { label: "Status", value: "is_active" },
    { label: "Action", value: "actions" },
  ];

  const navigatePage = {
    create: "/dispatched-create",
    edit: "/dispatched-create",
    view: "/dispatched-view",
  };

  // keep this in sync with the columns rendered by DispatchedList.js
  const searchfields = [
    "dispatched_no",
    "remark",
    "dispatch_date",
    "intake.intake_no",
    "intake.material_serial_no",
    "intake.material.gmds_code",
    "job_card.job_card_no",
    "dispatched_by_user.first_name",
    "dispatched_by_user.last_name",
  ];

  const filterConfig = [
    DISPATCHED_SERIAL_NO_FILTER,
    DISPATCHED_GMDS_CODE_FILTER,
    DISPATCHED_BY_FILTER,
    {
      key: "is_invoice_generated",
      label: "Invoice Generated",
      width: 185,
      options: YES_NO_OPTIONS,
    },
    STATUS_FILTER,
  ];

  const headerName = "Dispatched";
  const endpoint = "/getRecords";
  const exportFileName = "DispatchedData.xlsx";

  return {
    payload,
    navigatePage,
    headerName,
    columnData,
    endpoint,
    searchfields,
    exportFileName,
    filterConfig,
  };
};

export const exportPageData = {
  modelName: "dispatcheds",
  schema: schema,
  include: [
    {
      model: "material_intakes",
      as: "intake",
    },
    {
      model: "user_masters",
      as: "dispatched_by_user",
    },
  ],

  pagination: { page: 1, pageSize: 10000 },
};
